if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isCarousel = this.hasAttribute('data-carousel');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Preload the rest of the carousel images AFTER the lightbox has opened
        // and painted. Doing it synchronously on the click (and with
        // decoding:'sync') blocked the main thread for hundreds of ms — up to
        // several seconds on high-res wallpapers — which was the worst gallery
        // INP. Defer to idle so the open feels instant.
        if (this.isCarousel) {
          const preload = () => this.preloadAllImages();
          if ('requestIdleCallback' in window) {
            requestIdleCallback(preload, { timeout: 800 });
          } else {
            requestAnimationFrame(() => setTimeout(preload, 0));
          }
        }
      }

      preloadAllImages() {
        // Find all images in the modal and start loading them (async decode so
        // we never block the main thread on decode).
        this.querySelectorAll('img[data-media-id], [data-media-id] img').forEach((img) => {
          img.loading = 'eager';
          img.decoding = 'async';

          if (img.dataset.src) {
            img.src = img.dataset.src;
          }

          // The real image now loads eagerly using its own sizes/srcset.
          // A second Image object can fetch an unnecessary larger candidate.
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`) ||
          this.querySelector('[data-media-id]');
        if (!activeMedia) return;
        const activeImage = activeMedia.matches('img') ? activeMedia : activeMedia.querySelector('img');
        if (activeImage) {
          activeImage.loading = 'eager';
          activeImage.decoding = 'async';
        }
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Only scroll into view if not carousel mode
        if (!this.isCarousel) {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
